import ANOMALY_RULE_CODES, { getAnomalyRuleLabelKey } from "../../../../../core/constants/anomalyRuleCodes";

const TIMELINE_RULE_LENS = [
  { value: "", labelKey: "MetricAnomalyTimeline.ruleAll.label" },
  ...ANOMALY_RULE_CODES.map((rule) => ({
    value: rule.value,
    labelKey: getAnomalyRuleLabelKey(rule.value),
  })),
];

export default TIMELINE_RULE_LENS;
